
import { Editor } from "@tiptap/react";
import {
  AlignLeft,
  AlignCenter,
  AlignRight,
  Bold,
  Italic,
  Link,
  ListOrdered,
  List,
  Code,
  Link2Off
} from "lucide-react";
import { EditorToolbarButton } from "./EditorToolbarButton";

interface ToolbarControlsProps {
  editor: Editor;
}

export const ToolbarControls = ({ editor }: ToolbarControlsProps) => {
  const setLink = () => {
    const previousUrl = editor.getAttributes('link').href;
    const url = window.prompt('URL', previousUrl);

    // cancelled
    if (url === null) {
      return;
    }

    // empty
    if (url === '') {
      editor.chain().focus().unsetLink().run();
      return;
    }

    // Add http:// if no protocol is specified
    const formattedUrl = url.match(/^https?:\/\//) ? url : `http://${url}`;
    editor.chain().focus().setLink({ href: formattedUrl }).run();
  };

  return (
    <>
      <EditorToolbarButton
        onClick={() => editor.chain().focus().toggleBold().run()}
        active={editor.isActive("bold")}
        title="Bold"
      >
        <Bold className="h-4 w-4" />
      </EditorToolbarButton>

      <EditorToolbarButton
        onClick={() => editor.chain().focus().toggleItalic().run()}
        active={editor.isActive("italic")}
        title="Italic"
      >
        <Italic className="h-4 w-4" />
      </EditorToolbarButton>

      <EditorToolbarButton
        onClick={() => editor.chain().focus().toggleCode().run()}
        active={editor.isActive("code")}
        title="Code"
      >
        <Code className="h-4 w-4" />
      </EditorToolbarButton>

      <EditorToolbarButton
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        active={editor.isActive("bulletList")}
        title="Bullet List"
      >
        <List className="h-4 w-4" />
      </EditorToolbarButton>

      <EditorToolbarButton
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        active={editor.isActive("orderedList")}
        title="Ordered List"
      >
        <ListOrdered className="h-4 w-4" />
      </EditorToolbarButton>

      <EditorToolbarButton
        onClick={setLink}
        active={editor.isActive('link')}
        title="Add Link"
      >
        <Link className="h-4 w-4" />
      </EditorToolbarButton>

      <EditorToolbarButton
        onClick={() => editor.chain().focus().unsetLink().run()}
        active={false}
        title="Remove Link"
      >
        <Link2Off className="h-4 w-4" />
      </EditorToolbarButton>

      <EditorToolbarButton
        onClick={() => editor.chain().focus().setTextAlign('left').run()}
        active={editor.isActive({ textAlign: 'left' })}
        title="Align Left"
      >
        <AlignLeft className="h-4 w-4" />
      </EditorToolbarButton>
      
      <EditorToolbarButton
        onClick={() => editor.chain().focus().setTextAlign('center').run()}
        active={editor.isActive({ textAlign: 'center' })}
        title="Center"
      >
        <AlignCenter className="h-4 w-4" />
      </EditorToolbarButton>
      
      <EditorToolbarButton
        onClick={() => editor.chain().focus().setTextAlign('right').run()}
        active={editor.isActive({ textAlign: 'right' })}
        title="Align Right"
      >
        <AlignRight className="h-4 w-4" />
      </EditorToolbarButton>
    </>
  );
};
